<template>
  <el-date-picker
    v-model="pickerValue"
    size="small"
    style="width: 100%"
    type="daterange"
    value-format="yyyy-MM-dd"
    :range-separator="rangeSeparator"
    :start-placeholder="startPlaceholder"
    :end-placeholder="endPlaceholder"
    :picker-options="pickerOptions"
    :clearable="clearable"
    v-bind="$attrs"
  ></el-date-picker>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    rangeSeparator: {
      type: String,
      default: '-',
    },
    startPlaceholder: {
      type: String,
      default: '开始时间',
    },
    endPlaceholder: {
      type: String,
      default: '结束时间',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    pickerValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '本月',
            onClick(picker) {
              const now = new Date();
              const start = new Date(now.getFullYear(), now.getMonth(), 1); // 本月第一天
              const end = new Date(now.getFullYear(), now.getMonth() + 1, 0); // 本月最后一天
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '上月',
            onClick(picker) {
              const now = new Date();
              const start = new Date(now.getFullYear(), now.getMonth() - 1, 1); // 上月第一天
              const end = new Date(now.getFullYear(), now.getMonth(), 0); // 上月最后一天
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '本季度',
            onClick(picker) {
              const now = new Date();
              const currentMonth = now.getMonth();
              let startQuarterMonth;

              // 计算当前季度的起始月份
              if (currentMonth >= 0 && currentMonth <= 2) {
                // 第一季度 (1-3月)
                startQuarterMonth = 0; // 1月
              } else if (currentMonth >= 3 && currentMonth <= 5) {
                // 第二季度 (4-6月)
                startQuarterMonth = 3; // 4月
              } else if (currentMonth >= 6 && currentMonth <= 8) {
                // 第三季度 (7-9月)
                startQuarterMonth = 6; // 7月
              } else {
                // 第四季度 (10-12月)
                startQuarterMonth = 9; // 10月
              }

              const year = now.getFullYear();
              const start = new Date(year, startQuarterMonth, 1); // 季度第一天
              const end = new Date(year, startQuarterMonth + 3, 0); // 季度最后一天

              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '上季度',
            onClick(picker) {
              const now = new Date();
              const currentMonth = now.getMonth();
              let startQuarterMonth;

              // 计算上一季度的起始月份
              if (currentMonth >= 0 && currentMonth <= 2) {
                // 当前是第一季度，上季度是去年第四季度
                startQuarterMonth = 9; // 10月
              } else if (currentMonth >= 3 && currentMonth <= 5) {
                // 当前是第二季度，上季度是第一季度
                startQuarterMonth = 0; // 1月
              } else if (currentMonth >= 6 && currentMonth <= 8) {
                // 当前是第三季度，上季度是第二季度
                startQuarterMonth = 3; // 4月
              } else {
                // 当前是第四季度，上季度是第三季度
                startQuarterMonth = 6; // 7月
              }

              const year = currentMonth >= 0 && currentMonth <= 2 ? now.getFullYear() - 1 : now.getFullYear();

              const start = new Date(year, startQuarterMonth, 1);
              const end = new Date(year, startQuarterMonth + 3, 0); // 当月最后一天

              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '今年',
            onClick(picker) {
              const now = new Date();
              const start = new Date(now.getFullYear(), 0, 1); // 今年1月1日
              const end = new Date(now.getFullYear(), 11, 31); // 今年12月31日

              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '去年',
            onClick(picker) {
              const now = new Date();
              const year = now.getFullYear() - 1;
              const start = new Date(year, 0, 1); // 去年1月1日
              const end = new Date(year, 11, 31); // 去年12月31日

              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
    };
  },
};
</script>

<style lang="less" scoped></style>
